export enum BoxShadowTypes {
  DROP_SHADOW = 'dropShadow',
  INNER_SHADOW = 'innerShadow',
}
